import { useTranslations } from "use-intl";

import { LoginLink } from "@/components/login-link";
import { Button } from "@/components/ui/button";

export function CollectionPanelBulkAction({
  bulkReleaseCount,
  canAddMissing,
  isAdding,
  isAuthenticated,
  onAddMissing,
}: {
  bulkReleaseCount: number;
  canAddMissing: boolean;
  isAdding: boolean;
  isAuthenticated: boolean;
  onAddMissing: () => void;
}) {
  const t = useTranslations("featureCollections");
  const homeT = useTranslations("home");

  if (bulkReleaseCount === 0) return null;

  if (!isAuthenticated) {
    return (
      <Button className="mt-3 w-full" render={<LoginLink mode="signup" />} size="sm">
        {homeT("createAccount")}
      </Button>
    );
  }

  const label = isAdding ? t("adding") : t("addMissing", { count: bulkReleaseCount });

  return (
    <Button
      className="mt-3 w-full"
      disabled={isAdding || !canAddMissing}
      onClick={onAddMissing}
      size="sm"
    >
      {label}
    </Button>
  );
}
